import moment from 'moment';
import { APP_LANGUAGE_ENGLISH_VALUE } from 'src/constants/language-setting';

export const loadMomentLocale = async languageCode => {
  if (languageCode !== APP_LANGUAGE_ENGLISH_VALUE) await import(`moment/locale/${languageCode}`);
  moment.locale(languageCode);
};
